module.exports = "/_next/static/images/down-duotone-41a52dd5ecfa6e4ab03b1fe9223b04e4.svg";